import { ChevronDown } from '@tamagui/lucide-icons';
import { Row } from '@unistocks/components/layout/flex';
import { UnistocksCircle } from '@unistocks/components/logo/unistocks-circle';
import { Page } from '@unistocks/components/page/page';
import { Select } from '@unistocks/components/select/select';
import { t } from '@unistocks/localization';
import { ListResultDtoOfLookupDtoOfGuid } from '@unistocks/proxy/axios-client';
import { usePortfoliosGetListQuery } from '@unistocks/proxy/axios-client/PortfoliosQuery';
import { SelectOption } from '@unistocks/types';
import { SelectProps } from '@unistocks/types/select-props';
import React, { PropsWithChildren } from 'react';
import { isWeb, Spinner } from 'tamagui';

export type ImportHeaderTitleProps = PropsWithChildren<Pick<SelectProps, 'value' | 'onChange'>>;

const mapToSelectOptions = ({ items }: ListResultDtoOfLookupDtoOfGuid) =>
  items.map(
    ({ id, displayName }) =>
      ({ key: displayName, value: id, icon: <UnistocksCircle /> }) as SelectOption
  );

export const ImportHeaderTitle: React.FC<ImportHeaderTitleProps> = ({
  value,
  onChange,
  children
}) => {
  const {
    data: portfolios,
    isSuccess,
    isLoading
  } = usePortfoliosGetListQuery({
    structuralSharing: false,
    select: mapToSelectOptions
  });

  if (isLoading) return <Spinner color={'$headingFont'} />;

  if (isSuccess) {
    if (isWeb) {
      return <Page.Heading>{children}</Page.Heading>;
    }

    return (
      <Select
        options={portfolios}
        value={value}
        onChange={onChange}
        isRequired
        headerTitle={t('::Import:SelectTargetPortfolio')}
        trigger={
          <Row gap={'$1'} alignItems={'center'}>
            <Page.Heading>{children}</Page.Heading>
            <ChevronDown color={'$headingFont'} />
          </Row>
        }
      />
    );
  }

  return null;
};
